import { useSyncExternalStore } from 'react';
import { Capacitor } from '@capacitor/core';
import { createLiveUpdate } from '@delivery/shared/live-update';

export type { CheckResult, UpdateStatus } from '@delivery/shared/live-update';

/** 构建时写进来的本包版本。没有(本地 dev、网页版)就不参与热更新 */
export const BUNDLE_VERSION: string = import.meta.env['VITE_BUNDLE_VERSION'] ?? 'dev';

const isNative = Capacitor.isNativePlatform();

/** 热更新(逻辑在 shared,和司机端共用;插件按需加载,网页版不打进去) */
const lu = createLiveUpdate({
  isNative,
  bundleVersion: BUNDLE_VERSION,
  updateUrl: import.meta.env['VITE_UPDATE_URL'] ?? '',
  loadUpdater: async () => {
    if (!isNative) return null;
    try {
      const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
      // 包一层再返回 —— 插件 Proxy 会被 await 当成 Promise 卡死,见 shared 里的说明
      return { updater: CapacitorUpdater };
    } catch {
      return null;
    }
  },
  nativeAppVersion: async () => {
    if (!isNative) return null;
    try {
      const { App } = await import('@capacitor/app');
      return (await App.getInfo()).version;
    } catch {
      return null;
    }
  },
  onAppResume: async (cb) => {
    if (!isNative) return;
    const { App } = await import('@capacitor/app');
    await App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) cb();
    });
  },
});

export const liveUpdateEnabled = lu.enabled;
export const checkNow = lu.checkNow;
export const applyNow = lu.applyNow;
export const startLiveUpdate = lu.start;
export const dismissUpdate = lu.dismiss;

/** 更新状态(新版本就绪 / 要重装壳)—— 提示条和「检查更新」按钮共用 */
export function useUpdateStatus() {
  return useSyncExternalStore(lu.subscribe, lu.getStatus);
}
